import { createKeyboardEvent } from "./keyboard";

export default function initRemoteControl() {
  let raf = null;
  let pending = null;
  let lastTime = 0;
  const LIMIT_MS = 100; 
  
  const normalizeKey = (k) => {
    switch (k) {
      case "Up": return "ArrowUp";
      case "Down": return "ArrowDown";
      case "Left": return "ArrowLeft";
      case "Right": return "ArrowRight";
      case "Select": return "Enter";
      default: return k;
    }
  };

  const send = (key) => {
    const ev = createKeyboardEvent(key);
    document.dispatchEvent(ev);
  };

  const flush = () => {
    raf = null;
    const k = pending;
    pending = null;
    if (!k) return;

    const now = performance.now();
    if (now - lastTime >= LIMIT_MS) {
      lastTime = now;
      send(k);
    }
  };

  function handleMessage({ data }) {
    if (!data || data.type !== "tvremote") return;

    const keyNorm = normalizeKey(data.key);

    if (
      keyNorm === "ArrowUp" ||
      keyNorm === "ArrowDown" ||
      keyNorm === "ArrowLeft" ||
      keyNorm === "ArrowRight"
    ) {
      pending = keyNorm;
      if (raf == null) raf = requestAnimationFrame(flush);
      return;
    }

    send(keyNorm);
  }

  window.addEventListener("message", handleMessage);
}